<mat-form-field class="full-width">
  <mat-label>{{option.label | translate :{allow_with:option.allowWith} }}</mat-label>
  <span *ngIf="option.type === 'password'">
  <input name="{{option.name}}" type="{{option.type | translate}}" matInput
    placeholder="{{option.placeholder | translate :{allow_with:option.allowWith} }}" [value]="option.value"
    autocomplete="{{option.autocomplete}}" showHidePWD>
  </span>
  <input *ngIf="option.type !== 'password'" name="{{option.name}}" type="{{option.type | translate}}" matInput
  placeholder="{{option.placeholder | translate :{allow_with:option.allowWith} }}" [value]="option.value"
  autocomplete="{{option.autocomplete}}" disabled="{{option.inputDisabled ?? false}}">
  <mat-hint *ngIf="option.value !== ''">{{option.hint | translate}}</mat-hint>
  <mat-hint *ngIf="option.value === ''" class="mat-error"> {{option.error | translate}}</mat-hint>
</mat-form-field>
